import React, { useState, useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Header from "../../components/landing/Header";
import Footer from "../../components/landing/Footer";
import { useTranslation } from "../../contexts/TranslationContext";

import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import icon1 from "../../assets/images/icon1.png";
import icon2 from "../../assets/images/icon2.png";
import icon3 from "../../assets/images/icon3.png";
import icon4 from "../../assets/images/icon4.png";
import icon5 from "../../assets/images/icon5.png";
import icon6 from "../../assets/images/icon6.png";

import screenshot1 from "../../assets/images/ss1.png";
import screenshot2 from "../../assets/images/ss2.png";
import screenshot3 from "../../assets/images/ss3.png";
import screenshot4 from "../../assets/images/ss4.png";
import screenshot5 from "../../assets/images/ss5.png";

import downloadImg from "../../assets/images/download-mobile.png";

import appleBtn from "../../assets/images/appleBtn.png";
import googleBtn from "../../assets/images/googleBtn.png";

import bannerLeftImg from "../../assets/images/mobile-left.png";
import bannerSSr from "../../assets/images/mobile-right.png";

import aboutImg from "../../assets/images/about.png";

const HomePage = () => {

  const navigate = useNavigate();
  const [scrollX, setScrollX] = useState(0);
  const [currentScreenshot, setCurrentScreenshot] = useState(0);
  const { t, isRTL } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  const features = [
    {
      title: t("features.feature1.title"),
      text: t("features.feature1.description"),
      icon: "bi bi-shield-check",
      gradient: "green-gradient",
    },
    {
      title: t("features.feature2.title"),
      text: t("features.feature2.description"),
      icon: "bi bi-calendar-check",
      gradient: "gray-gradient",
    },
    {
      title: t("features.feature3.title"),
      text: t("features.feature3.description"),
      icon: "bi bi-rocket-takeoff",
      gradient: "orange-gradient",
    },
  ];

  const servicesList = [
    { icon: icon1, title: t("services.service1.title"), text: t("services.service1.description") },
    { icon: icon2, title: t("services.service2.title"), text: t("services.service2.description") },
    { icon: icon3, title: t("services.service3.title"), text: t("services.service3.description") },
    { icon: icon4, title: t("services.service4.title"), text: t("services.service4.description") },
    { icon: icon5, title: t("services.service5.title"), text: t("services.service5.description") },
    { icon: icon6, title: t("services.service6.title"), text: t("services.service6.description") },
    { icon: icon6, title: t("services.service7.title"), text: t("services.service7.description") },
    { icon: icon6, title: t("services.service8.title"), text: t("services.service8.description") },
  ];

  const screenshots = [
    { id: 1, image: screenshot1 },
    { id: 2, image: screenshot2 },
    { id: 3, image: screenshot3 },
    { id: 4, image: screenshot4 },
    { id: 5, image: screenshot5 },
  ];

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreenshot((prevIndex) =>
        prevIndex === screenshots.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  return (
    <>
      <Header />
      {/* Banner Sec */}
      <section className="header-banner" id="home" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="container-fluid">
          <div className="row">
            {/* First Image - Desktop: left, Mobile: first in images row */}
            <div className="col-md-3 col-6 order-1 order-md-1">
              {/* <div data-aos="fade-right" data-aos-delay="200">
                <img src={bannerLeftImg} className="w-100" alt="" />
              </div> */}
            </div>
            
            {/* Second Image - Desktop: right, Mobile: second in images row */}
            <div className="col-md-3 col-6 order-2 order-md-3">
              {/* <div data-aos="fade-left" data-aos-delay="200">
                <img src={bannerSSr} className="w-100" alt="" />
              </div> */}
            </div>
            
            {/* Content - Desktop: center, Mobile: below images */}
            <div className="col-md-6 col-12 order-3 order-md-2">
              <div
                className="header-txt1"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <h1 className="banner-brand-title">
                  <span className={`banner-join ${isRTL ? 'isRTL' : ''}`}>{t("banner.title1")}</span>
                  <span className="handyman-wrapper">
                    <span className={`handyman-txt ${isRTL ? 'isRTL' : ''}`}>{t("banner.handyman")}</span>
                    {/* <img
                      src={bannerBrush}
                      alt=""
                      className="handyman-img"
                      data-aos="zoom-in"
                      data-aos-delay="800"
                    /> */}
                  </span>
                </h1>

                <h1 className={`banner-headline ${isRTL ? 'isRTL' : ''}`}
                 data-aos="fade-up" data-aos-delay="600" dangerouslySetInnerHTML={{ __html: t("banner.title2") }}>
                  {/* {t("banner.title2")}  */}
                  {/* <span className="professional-txt">{t("banner.title2_event_services")}</span> */}
                </h1>
                <p className={`banner-para ${isRTL ? 'isRTL' : ''}`}
                 data-aos="fade-up" data-aos-delay="800">
                  {t("banner.description")} 
                </p>
              </div>
              <div
                className="banner-btns d-flex justify-content-center align-items-center gap-3"
                data-aos="fade-up"
                data-aos-delay="1000"
              >
                <ScrollLink
                  to="downloadApp"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  className="btn fw-bold py-2 shadow download-btn rounded-pill text-white pt-7"
                  data-aos="zoom-in"
                  data-aos-delay="1200"
                >
                  {t("banner.downloadApp")}
                </ScrollLink>

                <ScrollLink
                  to="services"
                  smooth={true}
                  duration={500}
                  spy={true}
                  offset={-80}
                  className="btn fw-bold py-2 shadow services-btn rounded-pill text-white pt-7"
                  data-aos="zoom-in"
                  data-aos-delay="1200"
                >
                  {t("banner.ourServices")}
                </ScrollLink>

             
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="container mt-5 text-center" id="about" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="company-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            {t("about.title")} <span className="company-txt">{t("about.companyName")} </span>
          </h1>
          <p
            className="mt-5 company-para"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            {t("about.description")}
          </p>
        </div>
        <div className="row my-5">
          <div class="col-md-3 col-sm-12">
            {/* <div
              className="company-worker"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <img src={aboutImg} className="w-100 rounded-5" alt="" />
            </div> */}
          </div>
          <div class="col-md-6 col-sm-12 ">
            <div class="company-worker-right">
                <div
                  className="shadow rounded-4 px-5 py-4 text-start my-5 company-worker-right-details"
                  data-aos="fade-left"
                  data-aos-delay="400"
                >
                  <h2>{t("about.feature1.title")}</h2>
                  <p>
                    {t("about.feature1.description")}
                  </p>
                </div>
                <div
                  className="shadow rounded-4 px-5 py-4 text-start my-5 company-worker-right-details"
                  data-aos="fade-left"
                  data-aos-delay="600"
                >
                  <h2>{t("about.feature2.title")}</h2>
                  <p>
                    {t("about.feature2.description")}
                  </p>
                </div>
                <div
                  className="shadow rounded-4 px-5 py-4 text-start my-5 company-worker-right-details"
                  data-aos="fade-left"
                  data-aos-delay="800"
                >
                  <h2>{t("about.feature3.title")}</h2>
                  <p>
                    {t("about.feature3.description")}
                  </p>
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Best Service */}
      <section
        className="container-fluid text-center  top services-section"
        id="services"
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <div className="services-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            {t("services.title")} <span className="services-txt">{t("services.subtitle")}</span>
          </h1>
          <p
            className="mt-4 company-para"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            {t("services.description")}
          </p> 
        </div> 
        <div className="container py-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
            {servicesList.map((item, index) => (
              <div className="col" key={index}>
                <div
                  className="service1 rounded-4"
                  data-aos="fade-up"
                  data-aos-delay={200 + index * 100}
                >
                  <div className="service-icon-box">
                    <img src={item.icon} alt="" />
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="container-fluid text-center " id="features" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="features-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            {t("features.title")} <span className="feature-txt">{t("features.subtitle")}</span> {t("features.subtitle2")}
          </h1>
          <p
            className="mt-4 company-para"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            {t("features.description")}
          </p>
        </div> <br />

        <Container className="my-5">
          <Row className="g-4 justify-content-center">
            {features.map((item, index) => (
              <Col key={index} md={4} sm={6}>
                <div
                  className={`feature-card ${item.gradient}`}
                  data-aos="slide-up"
                  data-aos-delay={200 + index * 200}
                >
                  <div className="feature-icon">
                    <i className={`fs-1 text-base ${item.icon}`}></i>
                  </div>
                  <div className="card-content">
                    <h5>{item.title}</h5>
                    <p className="mb-0 text-start">{item.text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <main className="position-relative">
        {/* Our Mobile App */}
       

        {/* Download our App */}
        <section className="container-fluid download-App-main" id="downloadApp" dir={isRTL ? 'rtl' : 'ltr'}>
          <div className="container">
            <div className="row downloadApp">
              <div
                className="col-md-6 download-text d-flex flex-column justify-content-center align-items-start"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <h1
                  className="fw-bold"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  {t("download.title")}
                  <span
                    className="for-free d-inline-block text-center ms-2"
                    data-aos="zoom-in"
                    data-aos-delay="600"
                  >
                    {t("download.subtitle")}
                  </span>
                </h1>

                <p
                  className="fw-light mt-3"
                  data-aos="fade-up"
                  data-aos-delay="800"
                >
                  {t("download.description")}
                </p>
                <div className="d-flex gap-3 download-btns-white mt-5">
                  <img src={appleBtn} alt="" />
                  <img src={googleBtn} alt="" />
                </div>
              </div>

              <div
                className="col-md-6 d-flex justify-content-center align-items-center"
                data-aos="fade-left"
                data-aos-delay="400"
              >
                <div className="download-img-ss">
                  <img
                    src={downloadImg}
                    className="download-screenshot"
                    alt=""
                    data-aos="zoom-in"
                    data-aos-delay="600"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomePage;
